export const LEVEL = {
  1: '低危',
  2: '中危',
  3: '高危',
  4: '严重',
}

export const BUG_STATUS = {
  '-1': '已提交',
  0: '审核中',
  1: '已确认',
  2: '已修复',
  3: '已完成',
  4: '已忽略',
}

export const NOTICE_TYPE = {
  1: '通知',
  2: '活动',
  3: '新闻',
  4: '招聘',
}

export const IOT_STATUS = {
  NOT_START: 0,
  ING: 1,
  EXPIRED: 2,
}

export const FILE_TYPES =
  'application/msword,application/wps-office.doc,application/wps-office.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-7z-compressed,application/zip,application/x-gzip,application/pdf,application/wps-office.pdf'

export const FILE_MAX = 20971520
